export default __webpack_public_path__ + "static/media/i162jp.b91647c3.webp";